<div class="gojs-context-container padding-all-large flex">
    <section class="data-context-container" aria-label="Data Context Container">
        <div class="grid-x">
            <div class="cell large-4">
                <h2>Data Context</h2>
            </div>
            <div class="cell large-8 small-font-size">
                Top-level names reserved for system use: {{getRestrictedTopLevelNames()}}. <br />
                Sub-level names reserved for system use: {{getRestrictedSubLevelNames()}}.
            </div>
        </div>
        <workflow-context-tree [template]="template" (contextCopied)="copyContext($event)"></workflow-context-tree>
    </section>
    <section class="entity-mapping-container" aria-label="Entity Mapping Container">
      <h2>Entity Data Mapping</h2>
      <workflow-entity [template]="template" [copiedContext]="copiedContext"></workflow-entity>
    </section>
</div>